export default __webpack_public_path__ + "static/media/xcarve.4ebbc37b.png";